export default __webpack_public_path__ + "static/media/news18.807a63bc.jpg";